import { useEffect } from "react";
import { BRAND } from "@/lib/brand";

export function useSeo(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
    return () => {
      document.title = `${BRAND.name} | Quality Used Cars in Nampa, Idaho`;
    };
  }, [title, description]);
}

export function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return undefined;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, [id, data ? JSON.stringify(data) : null]);
}
